import axios from "axios";
import pick from "lodash/pick";

import publicConfig from "@/config/public";
import { GeolocationResult } from "@/custom-types/GeolocationResult";

const {
  services: {
    geoIpApi: { url: geoIpApiUrl },
  },
} = publicConfig;

export default async (ip?: string) => {
  try {
    const response = await axios.get<GeolocationResult>(
      `${geoIpApiUrl}/geo/v1/geoip${ip ? `/${ip}` : ""}`,
    );

    if (response?.status === 200) {
      return pick(response.data, [
        "city",
        "coordinates",
        "country_code",
        "country",
        "formatted_location",
        "place_id",
        "slug",
        "state_code",
        "state",
        "street",
        "sublocality",
        "zip",
      ]);
    }
  } catch {
    return;
  }
};
